import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
export function ParticlesBackground() {
  // Generamos las partículas solo una vez al montar el componente
  const particles = useMemo(() => {
    return Array.from({
      length: 80
    }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: Math.random() * 2.5 + 0.5,
      duration: Math.random() * 20 + 15,
      delay: Math.random() * 20,
      drift: Math.random() * 100 - 50 // Desplazamiento horizontal (-50px a 50px)
    }));
  }, []);
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-190">
      {particles.map(p => <motion.div key={p.id} className="absolute bg-white rounded-full" style={{
      left: `${p.left}%`,
      top: `${p.top}%`,
      width: p.size,
      height: p.size,
      boxShadow: `0 0 ${p.size * 3}px rgba(255, 255, 255, 0.9)` // Efecto luminoso
    }} animate={{
      y: [0, -300],
      x: [0, p.drift],
      opacity: [0, 0.8, 0],
      scale: [0.5, 1.5, 0.5] // Laten un poco en tamaño
    }} transition={{
      duration: p.duration,
      repeat: Infinity,
      delay: p.delay,
      ease: 'linear'
    }} data-id="element-191" />)}
    </div>;
}